// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__4fWax","title":"FrontImage_title__1UT3l"};